<template lang="pug">
    header#header(:class="{ condensed, 'open': open}" @click.self="controlMenu(false)")
        ul.redes
            li.rede(v-if="$configuracoes.instagram")
                a(:href="$configuracoes.instagram", target="_blank")
                    FontAwesomeIcon(:icon="icons.faInstagram")
            li.rede(v-if="$configuracoes.facebook")
                a(:href="$configuracoes.facebook", target="_blank")
                    FontAwesomeIcon(:icon="icons.faFacebook")
        h1(@click="controlMenu(false)")
            router-link(:to="{ name: 'home' }")
                | Elissa Village
                SvgIcon(data="@svgs/logos/logo.svg")
        nav.menu
            ul.items
                li(v-for="item in menu", @click="controlMenu(false)").item
                    router-link(:to="{ name: 'pagina', params: { slug: item.page.slug } }", v-if="!item.externo") {{ item.title }}
                    a(:href="item.link_externo", target="_blank", v-else) {{ item.title }}
            .contato(v-if="loaded && showContato")
                a(:href="$configuracoes.whatsappLink") 
                    FontAwesomeIcon(:icon="icons.faWhatsapp")
                    | Vamos conversar?
        button(@click="controlMenu()").icon-menu
            FontAwesomeIcon(:icon="icons.faBars")
</template>

<script>
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faFacebookSquare as faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'

export default {
    name: "component-header",
    props: {
        showContato: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            icons: {
                faBars,
                faWhatsapp,
                faFacebook, 
                faInstagram,
            },
            condensed: false,
            open: false,
            loaded: false,
            menu: [],
        }
    },
    created() {
        this.$eventbus.$on('loaded-configuracoes', () => this.loaded = true)
        this.loadMenu()
        window.addEventListener('scroll', () => {
            if (window.scrollY >= 50)
                this.condensed = true
            else
                this.condensed = false
        })
    },
    methods: {
        controlMenu(value = null) {
            if(value)
                this.open = value
            else
                this.open = !this.open
        },
        loadMenu() {
            this.$axios
                .get(`menu`)
                .then(response => this.menu = response.data)
        },
    }
}
</script>

<style lang="stylus" scoped src="./Header.styl"></style>